/* One vector design powers both the live preview and the downloadable pass. */
(function (root) {
  'use strict';
  const acts = { nap: 'The unapologetic nap.', sofa: 'Sofa. So good.', clouds: 'Head in the clouds.', tea: 'A very slow cuppa.', nothing: 'Absolutely nothing.' };
  const escape = text => String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));
  const characters = text => Array.from(String(text));
  function lines(text, limit) {
    const result = []; let line = '';
    for (const word of String(text).split(/\s+/)) {
      if (characters(word).length > limit) {
        if (line) { result.push(line); line = ''; }
        const chars = characters(word);
        while (chars.length > limit) result.push(chars.splice(0, limit).join(''));
        line = chars.join('');
      } else if (characters(line ? line + ' ' + word : word).length > limit) { result.push(line); line = word; }
      else line = line ? line + ' ' + word : word;
    }
    if (line) result.push(line);
    return result;
  }
  function passReference(pledge) {
    let hash = 2166136261;
    for (const char of [pledge.name, pledge.act, pledge.custom, pledge.minutes, pledge.location, pledge.snacks].join('|')) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
    return 'SLO-' + hash.toString(36).toUpperCase().padStart(7, '0');
  }
  function render(pledge, issued = false) {
    const name = pledge.name || 'Fellow sloth';
    const act = pledge.act === 'custom' ? pledge.custom || 'My own kind of lazy.' : acts[pledge.act] || acts.nap;
    const duration = pledge.minutes === 60 ? '1 hour' : pledge.minutes === 120 ? '2 hours' : (pledge.minutes || 30) + ' minutes';
    const location = pledge.location || 'Wherever you switch off.';
    const snacks = pledge.snacks || 'Your call. No judgement.';
    const reference = typeof pledge.passId === 'string' && /^SLO-[A-Z0-9-]{6,40}$/.test(pledge.passId) ? pledge.passId : passReference(pledge);
    const field = (label, value, x, y, width = 365) => {
      const content = lines(value, 23);
      const fontSize = characters(value).length > 36 ? 25 : 29;
      return `<text x="${x}" y="${y}" class="label">${label}</text>${content.map((line, i) => `<text x="${x}" y="${y + 42 + i * 33}" font-size="${fontSize}" class="mono">${escape(line)}</text>`).join('')}`;
    };
    let x = 205; const bars = [];
    for (let i = 0; i < 72; i++) {
      const width = 2 + (reference.charCodeAt(i % reference.length) + i * 7) % 5;
      if (i % 2 === 0) bars.push(`<rect x="${x}" y="1174" width="${width}" height="72"/>`);
      x += width;
    }
    const nameSize = Math.min(40, Math.floor(770 / Math.max(1, characters(name).length)));
    const actLines = lines(act, 38);
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1350" viewBox="0 0 1080 1350" role="img" aria-labelledby="pass-title pass-desc">
<title id="pass-title">Sloth Pass — permission to pause</title><desc id="pass-desc">${escape(name)}: ${escape(act)} ${duration} off duty. Location: ${escape(location)} Snacks: ${escape(snacks)}. ${issued ? 'Pass issued.' : 'Pass preview.'}</desc>
<style>text{fill:#111;font-family:Arial,Helvetica,sans-serif}.label{font-size:19px;font-weight:700;letter-spacing:3px}.mono{font-family:'Courier New',monospace}</style>
<rect x="1" y="1" width="1078" height="1348" fill="#fff" stroke="#111" stroke-width="2"/>
<path d="M0 0h145v1350H0z" fill="#111"/>
<text x="-625" y="88" transform="rotate(-90)" text-anchor="middle" style="fill:#fff;font-size:58px;font-weight:900;letter-spacing:9px">PERMISSION TO PAUSE</text>
<text x="205" y="79" font-size="30" font-weight="900" letter-spacing="-1.5">slothmopolitan</text>
<text x="1017" y="77" text-anchor="end" class="mono" font-size="18">${issued ? 'PASS ISSUED' : 'PASS PREVIEW'}</text>
<text x="198" y="203" font-size="104" font-weight="900" letter-spacing="-7">SLOTH PASS</text>
<text x="205" y="248" class="mono" font-size="25" letter-spacing="3">YOUR LICENCE TO LAZY.</text>
<text x="196" y="401" font-size="151" font-weight="900" letter-spacing="-9">LA</text>
<path d="M478 347h112m-24-24 24 24-24 24" fill="none" stroke="#111" stroke-width="5"/>
<text x="660" y="401" font-size="151" font-weight="900" letter-spacing="-9">ZY</text>
<text x="205" y="446" class="mono" font-size="21" letter-spacing="3">GOOD FOR ONE SLOTH. GOING NOWHERE FAST.</text>
<path d="M145 486h873" stroke="#111" stroke-width="3"/>
<text x="205" y="535" class="label">PASSENGER</text>
<text x="205" y="585" font-size="${nameSize}" font-weight="700">${escape(name)}</text>
<text x="205" y="649" class="label">TODAY’S VERY IMPORTANT NON-PLANS</text>
${actLines.map((line, i) => `<text x="205" y="${697 + i * 41}" font-size="31" font-weight="700" class="mono">${escape(line)}</text>`).join('')}
${field('TIME OFF', duration, 205, 879)}
${field('BOARDING', 'At your own pace.', 630, 879)}
${field('LOCATION', location, 205, 996)}
${field('SNACK SELECTION', snacks, 630, 996)}
<path d="M0 1101h1080" stroke="#888" stroke-width="2" stroke-dasharray="9 9"/>
<circle cx="0" cy="1101" r="17" fill="#fff"/><circle cx="1080" cy="1101" r="17" fill="#fff" stroke="#111" stroke-width="2"/>
<text x="205" y="1146" class="label">SLOMUNITY / SLOW CLASS</text>
<g aria-hidden="true">${bars.join('')}</g>
<text x="205" y="1281" class="mono" font-size="19" letter-spacing="2">${reference}</text>
<text x="630" y="1184" class="mono" font-size="20">GATE ZZZ · SEAT SOFA</text>
<text x="630" y="1229" font-size="28" font-weight="900" letter-spacing="-.8">BE LAZY FOR GOOD.</text>
<text x="630" y="1267" class="mono" font-size="20">slothmopolitan.com</text>
<text x="630" y="1304" class="mono" font-size="14">VALID WHENEVER. EXPIRES NEVER.</text>
</svg>`;
  }
  const api = { render, dataUri: (pledge, issued) => 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(render(pledge, issued)), passReference, lines };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.SlothPassRenderer = api;
})(typeof window !== 'undefined' ? window : globalThis);
